import OrderHttpService from "./order-http.service";

class MenuService extends OrderHttpService {
    list = (params) => this.get("product/products-list",params);

    add = (params) => this.post("product/add-products", params);

    update = (params,productId) => this.patch(`product/update-product/${productId}`,params);

    addProductLanguage = (params) => this.post(`productLanguage/add-product-languagae`, params);

    getProductLanguage = (params) => this.get(`productLanguage/product-language-list`, params);

    updateProductLanguage = (params, productLanguageId) => this.patch(`productLanguage/update-product-language/${productLanguageId}`, params);

    listAddons = (params) => this.get(`product/addons-list/${params.branchId}`);
}

export default new MenuService();